import React from "react";

export const ZoomIn = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="true"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 19 19"
    >
      <path
        fillRule="evenodd"
        d="M16.275 15.225L13.5 12.45c.9-1.125 1.5-2.625 1.5-4.2C15 4.5 12 1.5 8.25 1.5S1.5 4.5 1.5 8.25 4.5 15 8.25 15c1.575 0 3.075-.525 4.2-1.5l2.775 2.775a.81.81 0 00.525.225.81.81 0 00.525-.225c.3-.3.3-.75 0-1.05zM3 8.25A5.218 5.218 0 018.25 3a5.218 5.218 0 015.25 5.25c0 1.425-.6 2.775-1.5 3.675-.975.975-2.25 1.5-3.675 1.5C5.325 13.5 3 11.175 3 8.25zm7.5.75c.45 0 .75-.3.75-.75s-.3-.75-.75-.75H9V6c0-.45-.3-.75-.75-.75s-.75.3-.75.75v1.5H6c-.45 0-.75.3-.75.75S5.55 9 6 9h1.5v1.5c0 .45.3.75.75.75s.75-.3.75-.75V9h1.5z"
        clipRule="evenodd"
      />
    </svg>
  );
};
